import { xor } from './utils/xor';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getFolderTable } from 'owa-folders';
import { STICKY_NOTE_FOLDER_CLASS } from 'owa-folders-constants';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Restriction that matches when the selected folder is a notes (sticky note) folder, identified by
 * its FolderClass rather than a distinguished folder id. This catches the non-default sticky note
 * folder synced for archive mailboxes, which folderRestriction([notesFolderId]) misses because it
 * is not a distinguished 'notes' folder. Mail item actions (reply, forward, flag, download, etc.)
 * are not supported for notes folders, so this is used to hide those menu items.
 *
 * Gated behind the 'fp-archive-notes-folder' feature flight.
 *
 * @param shouldHide when true, hide the item in notes folders (mirrors folderRestriction semantics).
 */
export const notesFolderClassRestriction = (shouldHide?: boolean) => (): boolean => {
    const isNotesFolder =
        isGlobalFeatureEnabled('fp-archive-notes-folder') && isSelectedFolderStickyNoteClass();
    return xor(shouldHide, isNotesFolder);
};

function isSelectedFolderStickyNoteClass(): boolean {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    const folderId = tableView && tableView.tableQuery.folderId;
    if (!folderId) {
        return false;
    }
    return getFolderTable().get(folderId)?.FolderClass === STICKY_NOTE_FOLDER_CLASS;
}
